export enum PaginationSize {
    SM = "sm",
    MD = "md",
    LG = "lg"
}
export enum PaginationSize {
    SM = "sm",
    MD = "md",
    LG = "lg"
}
